var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject } from "~/core/decorator";
import { FilterService } from "~/utils/filter.service";
var TurnRecordService = /** @class */ (function () {
    function TurnRecordService() {
    }
    /**
     * 分页获取流转记录
     */
    TurnRecordService.prototype.findTurnRecordDetailPage = function (caseNumber, queryData, page) {
        return this.netService.send({
            server: domainService.turnRecordController.findTurnRecordDetailPage,
            data: {
                caseNumber: caseNumber,
                caseTurnTimeStart: FilterService.dateRanageFormat(queryData.caseTurnTime)
                    .start,
                caseTurnTimeEnd: FilterService.dateRanageFormat(queryData.caseTurnTime).end,
                triggerAction: queryData.triggerAction,
                operatorRealName: queryData.operatorRealName
            },
            page: page
        });
    };
    /**
     * 案件流转查询
     */
    TurnRecordService.prototype.findAllTurnRecord = function (data, page) {
        return this.netService.send({
            server: domainService.turnRecordController.findAllTurnRecord,
            data: data,
            page: page
        });
    };
    __decorate([
        Inject(NetService)
    ], TurnRecordService.prototype, "netService", void 0);
    return TurnRecordService;
}());
export { TurnRecordService };
